'use strict';
import { CommonProcs } from "./common";

window.addEventListener('DOMContentLoaded', function(event)
{
    //console.log('webmark');
    let url = localStorage.getItem('common.modified.url')
    if((null != url) && (0 < url.length)) {
        console.log('url:' + url);
        localStorage.setItem('common.modified.url', '')
        if(!this.confirm("変更が保存されていません。\nページを離れますか？")) {
            this.history.back()
        }
    }

    // 送信ボタン活性化
    enableSubmitButton(event, true);

    // データ送信時イベントリスナ登録 
    $('.form-role-submit').on('submit', onSubmitForm);

    // メンテナンス通知表示制御
    showMaintenanceNotice()

    // リサイズをハンドル
    onResizeWindow(false)
    window.addEventListener('resize', function() {
        onResizeWindow(true)
    })

})

/**
 * メンテナンス通知表示制御
 */
function showMaintenanceNotice()
{
    let maintenanceNotice = $('#maintenanceNotice').val()
    let maintenanceToday = $('#maintenanceToday').val()
    let maintenanceFrom = $('#maintenanceFrom').val()
    let maintenanceTo = $('#maintenanceTo').val()
    //console.log('maintenanceNotice:' + maintenanceNotice)
    if('1' == maintenanceNotice) {
        // メンテナンス通知有効
        let closeDate = localStorage.getItem('maintenance.close-date')
        if(closeDate != maintenanceToday) {
            // 今日は閉じるボタンを押してない
            // 通知領域を表示する
            $('#maintenanceNoticeArea').css('display', 'flex')
            $('#schedule').html(maintenanceFrom + ' ～ ' + maintenanceTo)
            // イベントリスナー：閉じるボタン
            $('#maintenanceNoticeClose').on('click', ()=>{
                // 通知領域を非表示にする
                $('#maintenanceNoticeArea').css('display', 'none')
                // 押された日は表示しない
                localStorage.setItem('maintenance.close-date', maintenanceToday)
            })
        }
    }    
}

/**
 * ウィンドウリサイズ時処理
 * @param {boolean} onEvent 
 */
function onResizeWindow(onEvent) 
{
    // window画面スクロールバー非表示(X座標は出すこともないはず)
    $('body').css('overflow-x', 'hidden');

    //console.log('webmark.onResizeWindow:' + onEvent)
    // BODY幅取得
    let cxBody = document.body.clientWidth

    // ロゴの位置と幅
    let ofsLogo = $('.app-logo').offset()
    let cxLogo = $('.app-logo').width()

    // 認証情報領域の幅取得
    let cxAuthInfos = $('.auth-infos').width()

    if((undefined !== ofsLogo) && (undefined !== cxLogo) && (undefined !== cxAuthInfos)) {
        const paddingTotal = 50 // いろいろな余白の合計（適当）
        // トップメニューの幅を計算して設定する
        let cxTopMenu = cxBody - (ofsLogo.left + cxLogo + cxAuthInfos + paddingTotal)
        //console.log('cxTopMenu:' + cxTopMenu)
        $('.top-menu-area').width(cxTopMenu)
    }
    // サイドメニュー領域サイズ調整
    CommonProcs.ADJUST_SIDE_MENU_AREA_SIZE()
}

/**
 * フォーム送信時動作メソッド
 */
function onSubmitForm(event)
{
    // 送信ボタン連打対策
    // submit を行った form の子孫要素に btn-role-submit classを持つボタンが連打できないよう、対策される
    enableSubmitButton(event,false);
}

/**
 * 送信ボタン活性状態コントロール
 * 
 * $(…).prop("disabled")を使用したかったが、disableだとsubmitまで無効化し、データが送信できないみたいなので使用しない
 * 参考：https://qiita.com/wallace_and_mirumit/items/332c64d88c6f45e31977
 */
function enableSubmitButton(event, enable)
{
    //console.log(event.target);
    if(enable) {
        // ボタン活性化
        $(event.target).find('.btn-role-submit').css('pointer-events', '');
    }
    if(!enable) {
        // ボタン非活性化
        $(event.target).find('.btn-role-submit').css('pointer-events', 'none');

        // ページ遷移前にボタンの活性状態を元に戻す
        window.onunload = function(){
            $(event.target).find('.btn-role-submit').css('pointer-events', '');
        }
    }
}
